<template>
  <div
    class="custom-select"
    :class="{ open: open }"
    :tabindex="tabindex"
    @blur="open = false"
  >
    <div class="selected" :class="{ open: open }" @click="open = !open">
      <span>{{ selected }}</span>
    </div>
    <div class="items" :class="{ selectHide: !open }">
      <div
        v-for="(option, i) of options"
        :key="i"
        @click="
          open = false;
          $emit('input', option);
        "
      >
        <div v-if="texts" v-html="texts[i]"></div>
        <div v-else>
          {{ option }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      required: true,
    },
    default: {
      type: String,
      required: false,
      default: null,
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0,
    },
    selected: {
      required: false,
    },
    texts: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {
      open: false,
    };
  },
  mounted() {
    this.selected = this.value ? this.value : this.selected;

    this.$emit("input", this.selected);
  },
};
</script>

<style scoped>
.custom-select {
  font-size: 1.2rem;
  position: static;
  width: 100%;
  text-align: left;
  outline: none;
  height: 3em;
  line-height: 3em;
}
.custom-select.open {
  position: relative;
  z-index: 1;
}
.custom-select .selected {
  cursor: pointer;
}
.custom-select.backgrounded .selected {
  background-color: #0d2942;
  border-radius: 6px;
  color: #fff;
  padding-left: 1em;
}

.custom-select .selected span {
  padding-left: 3px;
}
.custom-select .selected span:after {
  display: inline-block;
  width: 1.25rem;
  height: 1rem;
  content: "";
  background-image: url(data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNDAgMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbC1ydWxlPSJub256ZXJvIiBzdHJva2U9IiMwRDI5NDIiIHN0cm9rZS13aWR0aD0iNSIgZmlsbD0ibm9uZSIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSI+PHBhdGggZD0iTTMuNSAzLjVsMTYuMTQgMTYuMTRNMzYuMTQgNEwyMCAyMC4xNCIvPjwvZz48L3N2Zz4=);
  background-repeat: no-repeat;
  background-position: 0 4px;
  margin-left: 16px;
}

.custom-select .selected.open {
  border-radius: 6px 6px 0px 0px;
}

.custom-select.icon .selected:after {
  position: absolute;
  content: "";
  top: 22px;
  right: 1em;
  width: 0;
  height: 0;
  border: 5px solid transparent;
  border-color: #fff transparent transparent transparent;
}

.custom-select .items {
  color: #fff;
  border-radius: 6px;
  overflow: hidden;
  position: absolute;
  background-color: #0d2942;
  left: 0;
  right: 0;
  z-index: 10;
  display: block;
}

.custom-select .items div {
  color: #fff;
  padding-left: 1em;
  cursor: pointer;
  user-select: none;
}

.custom-select .items div:hover {
  background-color: #fc5c54;
}

.custom-select .items.selectHide {
  display: none;
}
</style>
